import { render, staticRenderFns } from "./imgrotation.vue?vue&type=template&id=ddb56834&scoped=true&"
import script from "./imgrotation.vue?vue&type=script&lang=js&"
export * from "./imgrotation.vue?vue&type=script&lang=js&"
import style0 from "./imgrotation.vue?vue&type=style&index=0&id=ddb56834&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb56834",
  null
  
)

export default component.exports